import { useEffect, useRef, useState } from "react";

const HOLD_MS = 4000;

export const useForwardingConfirmedHold = (): { holding: boolean; hold: () => void } => {
  const [holding, setHolding] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  const hold = (): void => {
    if (timer.current) clearTimeout(timer.current);
    setHolding(true);
    timer.current = setTimeout(() => setHolding(false), HOLD_MS);
  };

  return { holding, hold };
};
